import { z } from 'zod';

import { CustomerRoleResponseSchema } from './customer-role.schemas.js';

export const ListCustomerRolesByPartyResponseSchema = z.object({
  items: z.array(CustomerRoleResponseSchema),
});

export type ListCustomerRolesByPartyResponse = z.infer<
  typeof ListCustomerRolesByPartyResponseSchema
>;
